import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'source-group-page';
export const useSourceGroupPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = (__LOCALE_RU__ ? ({
  sourceGroupPage: {
    back_to_sources: 'Источники',
    save: 'Сохранить',
    save_success: 'Изменения сохранены',
    save_error: 'Не удалось сохранить изменения',
    save_validation_error: 'Исправьте ошибки в полях',
    unsaved_toast: 'Есть несохранённые изменения',
    section_stub: 'Раздел в разработке',
    load_error: 'Не удалось загрузить группу',
    back_to_list: 'Вернуться к источникам',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  sourceGroupPage: {
    back_to_sources: 'Sources',
    save: 'Save',
    save_success: 'Changes saved',
    save_error: 'Failed to save changes',
    save_validation_error: 'Fix the errors in the fields',
    unsaved_toast: 'There are unsaved changes',
    section_stub: 'Section under development',
    load_error: 'Failed to load the group',
    back_to_list: 'Back to sources',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  sourceGroupPage: {
    back_to_sources: 'Fuentes',
    save: 'Guardar',
    save_success: 'Cambios guardados',
    save_error: 'No se pudieron guardar los cambios',
    save_validation_error: 'Corrige los errores de los campos',
    unsaved_toast: 'Hay cambios sin guardar',
    section_stub: 'Sección en desarrollo',
    load_error: 'No se pudo cargar el grupo',
    back_to_list: 'Volver a fuentes',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  sourceGroupPage: {
    back_to_sources: 'Fontes',
    save: 'Salvar',
    save_success: 'Alterações salvas',
    save_error: 'Falha ao salvar alterações',
    save_validation_error: 'Corrija os erros nos campos',
    unsaved_toast: 'Há alterações não salvas',
    section_stub: 'Seção em desenvolvimento',
    load_error: 'Falha ao carregar o grupo',
    back_to_list: 'Voltar às fontes',
  },
}) : {}) as Record<string, unknown>;
